import { Transition } from '@headlessui/react';
import React, { Fragment } from 'react';
import { IButton } from '../../../../utils/types/contentful';
import { Button } from '../../Elements';

interface CardImageHoverProps {
  isHover: boolean;
  button: IButton;
}

export const CardImageHover: React.FC<CardImageHoverProps> = ({
  isHover,
  button,
}) => (
  <>
    <Transition
      show={isHover}
      as={Fragment}
      enter='ease-out duration-200'
      enterFrom='opacity-0'
      enterTo='opacity-100'
      leave='ease-in duration-200'
      leaveFrom='opacity-100'
      leaveTo='opacity-0'>
      <div
        className='absolute border-b inset-0 z-10 bg-gray-100 bg-opacity-50 backdrop-filter backdrop-blur-sm transition-opacity xs:hidden'
        aria-hidden='true'
      />
    </Transition>
    <Transition
      show={isHover}
      as={Fragment}
      enter='ease-out duration-600'
      enterFrom='opacity-0'
      enterTo='opacity-100'
      leave='ease-in duration-200'
      leaveFrom='opacity-100'
      leaveTo='opacity-0'>
      <div className='absolute w-full p-14 z-20 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 xs:hidden'>
        <Button
          size='base'
          fullWidth
          type='contained'
          color={{ classname: 'primary' }}
          label={{ text: button.label?.text }}
          icon={{
            iconKey: 'HiChevronRight',
            size: 'lg',
            color: { classname: 'white' },
          }}
        />
      </div>
    </Transition>
  </>
);
